(function () {
  if (window.tcQuickAddInitialized) return;
  window.tcQuickAddInitialized = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-tc-quick-add]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const spinner = button.querySelector('.loading-overlay__spinner');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    const payload = { items: [{ id: variantId, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'Unable to add this bottle.');
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          return fetch(window.routes.cart_url + '.js')
            .then(function (cartResponse) { return cartResponse.json(); })
            .then(function (cartData) {
              const cartLink = document.querySelector('#cart-icon-bubble');
              if (cartLink) {
                let bubble = cartLink.querySelector('.cart-count-bubble');
                if (!bubble) {
                  bubble = document.createElement('div');
                  bubble.className = 'cart-count-bubble';
                  cartLink.appendChild(bubble);
                }
                bubble.innerHTML = '<span aria-hidden="true">' + cartData.item_count + '</span><span class="visually-hidden">' + cartData.item_count + ' items</span>';
              }
              const label = button.querySelector('span:not(.sold-out-message)');
              if (label) {
                const original = label.textContent;
                label.textContent = 'ADDED';
                window.setTimeout(function () { label.textContent = original; }, 1600);
              }
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
            });
        }
      })
      .catch(function (error) {
        const soldOut = button.querySelector('.sold-out-message');
        if (soldOut) {
          button.querySelector('span:not(.sold-out-message)')?.classList.add('hidden');
          soldOut.textContent = error.message;
          soldOut.classList.remove('hidden');
        }
      })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  });
})();
